import React, { useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { Headline } from "../../components/Headline/Headline";
import { HTMLParser } from "../../components/HTMLParser/HTMLParser";
import { Chevron } from "../../components/Icons/Chevron";
import { Download } from "../../components/Icons/Download";
import { Section } from "../../components/Section/Section";
import { DIRECTUS_SERVER } from "../../config";
import { ArticlesContext } from "../../contexts/ArticlesContext";
import { FilesContext } from "../../contexts/FilesContext";
import { params } from "../../global/types";

export const ArticlePage: React.FC = () => {
  const { id } = useParams<params>();
  const articlesContext = useContext(ArticlesContext);
  const currentArticle = articlesContext.filteredArticlesById(id)[0];
  const pdfContext = useContext(FilesContext);
  const pdfIdsForCurrentArticle =
    currentArticle &&
    currentArticle.pdfs.map((pdf): number => pdf.directus_files_id);
  const currentPdfs = pdfContext.filteredPdfsByIds(pdfIdsForCurrentArticle);

  const history = useHistory();

  return (
    <div className="article-page page">
      {currentArticle && (
        <Section>
          <Container>
            <Row>
              <Col lg={{ span: 8, offset: 2 }}>
                <div className="back-link">
                    <button className="as-link" onClick={() => history.goBack()}>
                      <Chevron /><span>Zurück</span>
                    </button>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={{ span: 8, offset: 2 }}>
                <h4 className="over">{currentArticle.category.title}</h4>
                <Headline level="h1" bold={currentArticle.title} />
                <p className="lead">{currentArticle.subtitle}</p>
              </Col>
            </Row>
            <Row>
              <Col lg={{ span: 8, offset: 2 }}>
                <div className="article-page__content">
                  {currentArticle.article_content && (
                    <HTMLParser html={currentArticle.article_content} />
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={{ span: 8, offset: 2 }}>
                {currentPdfs && (
                  <div className="article-page__downloads">
                    {currentPdfs.map((pdf) => (
                      <a
                        key={pdf.id}
                        href={DIRECTUS_SERVER + pdf.data.asset_url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Download />
                        {pdf.title}{" "}
                        <small>
                          PDF [{(pdf.filesize / 1000).toFixed(2)} kB]
                        </small>
                      </a>
                    ))}
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </Section>
      )}
    </div>
  );
};
